import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-navy-dark py-20 border-y border-gold-accent/20" data-id="element-145">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy-light p-8 md:p-12 rounded-2xl shadow-2xl relative overflow-hidden" data-id="element-147">
          <div className="absolute -right-10 -top-10 text-navy-dark opacity-50" data-id="element-148">
            <Shield className="w-48 h-48" data-id="element-149" />
          </div>

          <div className="relative z-10" data-id="element-150">
            <Shield className="w-12 h-12 text-gold-accent mx-auto mb-6" data-id="element-151" />
            <p className="text-xl md:text-2xl font-body text-white leading-relaxed mb-6" data-id="element-152">
              Los datos del IRS muestran que el{' '}
              <span className="text-gold-accent font-bold text-3xl" data-id="element-153">70%</span>{' '}
              de los contribuyentes en EE.UU. son elegibles para declarar
              gratis, pero solo el{' '}
              <span className="text-red-400 font-bold text-3xl" data-id="element-154">3%</span> lo
              hace porque el camino está muy bien escondido.
            </p>
            <p className="text-lg text-gray-300 font-body font-semibold" data-id="element-155">
              La Guía de Libertad Fiscal cierra esa brecha y pone esos $150–$300
              de comisión de vuelta en tu bolsillo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}